import { LabelText } from '@policygenius/mortar';
import React from 'react';

import AccountIndicator from 'components/AccountIndicator';
import Icon from 'components/Icon';
import Link from 'components/Link';
import { PHONE_NUMBER } from 'containers/App/constants';

import styles from './nav-header.module.scss';
import { Props } from './types';

const NavHeader: React.FC<Props> = ({ email, firstName }) => (
  <div id="nav-header" className={styles.wrapper}>
    <img alt="" className={styles.logo} src="https://static.policygenius.com/logos/pg-lg.svg" />
    <div className={styles['contact-bar']}>
      <Link
        analyticsProperties={{
          text: PHONE_NUMBER,
          source: 'nav-header-navigator',
        }}
        aria-label={`Talk with a licensed expert at ${PHONE_NUMBER}`}
        className={styles['contact-bar-item']}
        href={`tel:${PHONE_NUMBER}`}
        target="_blank"
      >
        <Icon alt="" icon="phone" height="22px" width="22px" />
        <LabelText as="span" size="small" className={styles['contact-bar-item-phone-text']}>
          Talk with a licensed expert
          <br />
          {PHONE_NUMBER}
        </LabelText>
      </Link>
      {!!email && <AccountIndicator firstName={firstName} email={email} />}
    </div>
  </div>
);

export default NavHeader;
